<template>
  <Card>
    <template v-slot:header>
      <HeadingSmall>
        Welcome to the Implementation Checklist!
      </HeadingSmall>
    </template>
    <template v-slot:body>
      <ParagraphBody>
        This is your personalized checklist for getting started with JumpCloud.
        Build your onboarding flow by selecting features of interest.
      </ParagraphBody>
      <div>
        <img
          :class="$style.graphic"
          src="img/growth/road-image.png"
        >
      </div>
    </template>
  </Card>
</template>

<script>
import {
  Card,
  HeadingSmall,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'EmptyMessage',

  components: {
    Card,
    HeadingSmall,
    ParagraphBody,
  },
};
</script>

<style module>
.graphic {
  width: 100%;
}
</style>
